export default __webpack_public_path__ + "static/media/seal-csm.bf7f5d16.png";